import { render } from "./QuantityAdjustment.vue?vue&type=template&id=2c6afba0"
import script from "./QuantityAdjustment.vue?vue&type=script&lang=js"
export * from "./QuantityAdjustment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__